import { t } from '@repo/i18n';
import { useLocale } from '@repo/i18n/react';
import { Button } from '@repo/ui/button';
import { UserCircle, X } from 'lucide-react';
import { Activity } from 'react';

interface OwnersTableEmptyStateProps {
  searchQuery: string;
  onClearFilters: () => void;
  hasFilters: boolean;
}

export function OwnersTableEmptyState({
  searchQuery,
  onClearFilters,
  hasFilters,
}: OwnersTableEmptyStateProps) {
  useLocale();

  return (
    <div className="flex flex-col items-center justify-center py-12 text-center">
      <UserCircle className="mb-4 h-12 w-12 text-muted-foreground" />
      <h3 className="mb-2 font-semibold text-lg">{t('workspace.noOwnersFound')}</h3>
      <p className="text-muted-foreground">
        {searchQuery
          ? t('workspace.noOwnersMatchYourSearchCriteria')
          : t('workspace.thereAreNoOrganizationOwnersInTheSystemYet')}
      </p>
      <Activity mode={hasFilters ? 'visible' : 'hidden'}>
        <Button className="mt-4 bg-background" onClick={onClearFilters} variant="outline">
          <X className="h-4 w-4" />
          {t('workspace.clearFilters')}{' '}
        </Button>
      </Activity>
    </div>
  );
}
